import SecureBaseModel from './SecureBaseModel';

class PGModel extends SecureBaseModel { //PG - Payment Gateway

    //These have to match with the routes in backend > APIController
    static PG_ID = 'pg-id';
    static PG_PRE_SUBSCRIBE = 'pg-pre-subscribe';
    static PG_SUBSCRIBE = 'pg-subscribe';
    static PG_PM_UPDATE = 'pg-pm-update';
    static PG_FINALIZE_PM_UPDATE = 'pg-finalize-pm-update';
    static PG_AUTO_SYNC = 'pg-auto-sync';
    static PG_PENDING_SYNC = 'pg-pending-sync';
    static PG_UPDATE_SUBSCRIPTION = 'pg-update-subscription';
    static PG_SUBSCRIPTION_INFO = 'pg-subscription-info';
    static PG_RECEIPT_SOURCE = 'pg-receipt-source';
    static CREATE_SETUP_INTENT = 'create-setup-intents';
    static PG_POST_SUBSCRIBE = 'pg-post-subscribe';
    static PG_CANCEL_SUBSCRIPTION = 'pg-cancel-subscription';

    constructor() {
        super();
    }

    // returns: payment intent client secret key
    async getClientPGKey() {
        return await this.getData(PGModel.PG_ID);
    }

    // params { userId: value, sessionId: value, csMatNo: value, paymentMethodId: value }
    async beforeCreateSubscriptionChecks(params) {
        return await this.postData(PGModel.PG_PRE_SUBSCRIBE, params);
    }

    async createSubscription(params) {
        return await this.postData(PGModel.PG_SUBSCRIBE, params);
    }

    async postCreateSubscriptionChecks(params) {
        return await this.postData(PGModel.PG_POST_SUBSCRIBE, params);
    }

    async cancelSubscription(params) {
        return await this.postData(PGModel.PG_CANCEL_SUBSCRIPTION, params);
    }

    async updatePaymentMethod(params) {
        return await this.postData(PGModel.PG_PM_UPDATE, params);
    }

    async finalizeUpdatePaymentMethod(params) {
        return await this.postData(PGModel.PG_FINALIZE_PM_UPDATE, params);
    }

    // params { userId: value, sessionId: value
    async autoSyncSubscription(params) {
        return await this.postData(PGModel.PG_AUTO_SYNC, params);
    }

    // params { userId: value, sessionId: value
    async pendingSubscriptionSync(params) {
        return await this.postData(PGModel.PG_PENDING_SYNC, params);
    }

    // params { userId: value, sessionId: value, orderId: value, flag: value}
    async updateSubscriptionStatus(params) {
        return await this.postData(PGModel.PG_UPDATE_SUBSCRIPTION, params);
    }

    // params { userId: value, csOrderNo: value }
    async getSubscriptionInfo(params) {
        return await this.postData(PGModel.PG_SUBSCRIPTION_INFO, params);
    }

    // params { sessionId: value, csOrderNo: value, paymentLogSeq: value }
    async getReceiptSource(params) {
        return await this.postData(PGModel.PG_RECEIPT_SOURCE, params);
    }

    async createSetupIntent(params) {
        return await this.postData(PGModel.CREATE_SETUP_INTENT, params);
    }
}

export default PGModel;
